/**
 * The bag's standard look (studio-shop D4): its contents on the bag page, or
 * as the drawer a custom page places. Draws the behavior half's state and
 * calls its actions.
 */
import { BagBody } from './BagBody';
import { ShopBagDrawer } from './ShopBagDrawer';
import type { ShopBagRuntime } from './useShopBag';

export function ShopBagView(bag: ShopBagRuntime) {
  return bag.form === 'drawer' ? <ShopBagDrawer {...bag} /> : <BagBody {...bag} />;
}
